import styled from "styled-components";

const ScrollContainer = styled.div`
  max-width: 100%;
  overflow: auto;
  position: relative;
`;

export default ScrollContainer;
